import React, { lazy } from "react";

const GalleriesPageLazy = lazy(() => import("./index"));

export const GalleriesPage = (props) => <GalleriesPageLazy {...props} />;
